import { Link } from "react-router-dom";

const VARIANTS = {
  primary: "bg-accent text-white hover:bg-navy",
  secondary: "bg-transparent border border-navy/25 text-navy hover:bg-navy hover:text-cream hover:border-navy",
  ghost: "bg-transparent border border-cream/30 text-cream hover:bg-cream hover:text-navy",
};

export const CTAButton = ({
  to,
  href,
  onClick,
  variant = "primary",
  children,
  className = "",
  testId,
  type = "button",
}) => {
  const classes = `inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold tracking-wide transition-colors duration-300 ${VARIANTS[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={classes} data-testid={testId}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} data-testid={testId}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={classes} data-testid={testId}>
      {children}
    </button>
  );
};
